import React from 'react';
import ClassHome from './Class_home'; // Ensure the path is correct

const Classroom = () => {
    return (
        <div>
            <ClassHome />
        </div>
    );
};

export default Classroom;
